export {
  PEDIDO_VOO_STATUS,
  PEDIDO_VOO_STATUS_OPTIONS,
  PEDIDO_VOO_STATUS_FILTER_OPTIONS,
  PEDIDO_VOO_STATUS_TARGETS,
  canTransitionTo,
  getAvailableStatusActions,
  getPedidoVooStatusLabel,
} from './statusTransitions';

export const getCodigoPilotoSisant = (data) =>
  data?.codigoPilotoSisant ?? data?.codigoPilotoAnac ?? '';

export const hasPendingArquivoUpload = (arquivos) =>
  Array.isArray(arquivos) && arquivos.some((a) => a.new === true);
